var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"tree-auto-trade-logo",attrs:{"src":require("@/assets/images/logo/growth.png"),"alt":"트리자동매매"}})}
var staticRenderFns = []

export { render, staticRenderFns }